import {createFeatureSelector, createSelector} from '@ngrx/store';
import {IState} from '@models/iState';
import {ITopListingData, ITopListingState} from '@models/ITopListingStore';

export const topListingSelectorState = createFeatureSelector<ITopListingState>('topListing');
export const topListingPromotionTools = createSelector(topListingSelectorState, (state) => state.data.promotion_tools);
export const topListingDownlines = createSelector(topListingSelectorState, (state) => state.data.downlines);
